import React from 'react';

function AttachmentBubble({ att, isHost }) {
  const isImage = att.type && att.type.startsWith('image/');
  const fmtSize = (bytes) => {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024*1024) return (bytes/1024).toFixed(1) + ' KB';
    return (bytes/(1024*1024)).toFixed(1) + ' MB';
  };
  const iconForType = (type, name) => {
    if (type?.startsWith('image/')) return '🖼️';
    if (type?.includes('pdf') || name?.endsWith('.pdf')) return '📄';
    if (type?.includes('spreadsheet') || type?.includes('excel') || name?.match(/\.(xlsx?|csv)$/)) return '📊';
    if (type?.includes('word') || type?.includes('document') || name?.match(/\.docx?$/)) return '📝';
    if (type?.includes('zip') || name?.endsWith('.zip')) return '📦';
    return '📎';
  };
  return (
    <a href={att.url} target="_blank" rel="noopener noreferrer" style={{ textDecoration:'none' }}>
      <div style={{
        background: isHost ? '#2d2118' : '#fdf9f5',
        border: '1px solid ' + (isHost ? '#3d3020' : '#e8ddd0'),
        borderRadius:8, padding: isImage ? 4 : '8px 12px', overflow:'hidden',
        maxWidth: isImage ? 280 : undefined,
      }}>
        {isImage ? (
          <img src={att.url} alt={att.name}
            style={{ display:'block', maxWidth:'100%', borderRadius:6 }} />
        ) : (
          <div style={{ display:'flex', alignItems:'center', gap:8 }}>
            <span style={{ fontSize:20 }}>{iconForType(att.type, att.name)}</span>
            <div style={{ overflow:'hidden' }}>
              <div style={{ fontSize:13, fontWeight:600, color: isHost ? '#e8c97a' : '#1a1410', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{att.name}</div>
              {att.size && <div style={{ fontSize:11, color:'#a89a8a' }}>{fmtSize(att.size)}</div>}
            </div>
          </div>
        )}
      </div>
    </a>
  );
}

export default AttachmentBubble;
